(() => {
  if (window.__cloudXUgcStoriesLoaded) return;
  window.__cloudXUgcStoriesLoaded = true;

  const modulo = (number, length) => (number + length) % length;
  const videoFromCard = (card) => card?.querySelector('video');
  const coverFromCard = (card) =>
    card?.querySelector('video')?.poster ||
    card?.querySelector('img')?.currentSrc ||
    card?.querySelector('img')?.src ||
    '';
  const playIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7Z"/></svg>';
  const pauseIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zm6 0h4v14h-4z"/></svg>';
  const minimizeIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="5" width="12" height="9" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.8"/><rect x="9" y="10" width="11" height="9" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  const volumeIcon = (muted) => muted
    ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="m17 9 4 4m0-4-4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
    : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M16 9.5a4 4 0 0 1 0 5m2-8a8 8 0 0 1 0 11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  const init = (root) => {
    if (!root || root.dataset.cloudXUgcStoriesReady === 'true') return;
    root.dataset.cloudXUgcStoriesReady = 'true';

    const track = root.querySelector('[data-cloud-x-ugc-track]');
    const cards = [...(track?.querySelectorAll('[data-cloud-x-ugc-card]') || [])];
    const viewerCards = cards.filter((card) => videoFromCard(card) || card.querySelector('[data-cloud-x-ugc-external-template]'));
    const viewer = root.querySelector('[data-cloud-x-ugc-viewer]');
    const media = viewer?.querySelector('[data-cloud-x-ugc-viewer-media]');
    const title = viewer?.querySelector('[data-cloud-x-ugc-viewer-title]');
    const close = viewer?.querySelector('[data-cloud-x-ugc-close]');
    const minimize = viewer?.querySelector('[data-cloud-x-ugc-minimize]');
    const dismiss = viewer?.querySelector('[data-cloud-x-ugc-dismiss]');
    const viewerPrev = viewer?.querySelector('[data-cloud-x-ugc-viewer-prev]');
    const viewerNext = viewer?.querySelector('[data-cloud-x-ugc-viewer-next]');
    const sides = [...(viewer?.querySelectorAll('[data-cloud-x-ugc-side]') || [])];
    const center = viewer?.querySelector('[data-cloud-x-ugc-toggle]');
    const mute = viewer?.querySelector('[data-cloud-x-ugc-mute]');
    const share = viewer?.querySelector('[data-cloud-x-ugc-share]');
    const shareSheet = viewer?.querySelector('[data-cloud-x-ugc-share-sheet]');
    const shareClose = viewer?.querySelector('[data-cloud-x-ugc-share-close]');
    const progress = viewer?.querySelector('[data-cloud-x-ugc-progress]');
    const productCard = viewer?.querySelector('.cloud-x-ugc-product');
    const mini = root.querySelector('[data-cloud-x-ugc-miniplayer]');
    const miniMedia = mini?.querySelector('[data-cloud-x-ugc-miniplayer-media]');
    const miniToggle = mini?.querySelector('[data-cloud-x-ugc-miniplayer-toggle]');
    const miniClose = mini?.querySelector('[data-cloud-x-ugc-miniplayer-close]');

    if (!track || !cards.length || !viewer || !media || !mini || !miniMedia) {
      delete root.dataset.cloudXUgcStoriesReady;
      return;
    }

    const owner = root.dataset.cloudXSection || root.dataset.cloudXUgcSection || '';
    viewer.dataset.cloudXUgcPortaled = 'true';
    mini.dataset.cloudXUgcPortaled = 'true';
    if (owner) {
      viewer.dataset.cloudXUgcOwner = owner;
      mini.dataset.cloudXUgcOwner = owner;
    }
    document.body.append(viewer, mini);

    if (center) center.innerHTML = playIcon;
    minimize && (minimize.innerHTML = minimizeIcon);

    let viewerIndex = 0;
    let player = null;
    let miniPlayer = null;
    let raf = 0;
    let lastFocus = null;
    const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const previewRatios = new Map();

    const updateTrackArrows = () => {
      const previous = root.querySelector('[data-cloud-x-ugc-track-prev]');
      const next = root.querySelector('[data-cloud-x-ugc-track-next]');
      if (previous) previous.hidden = track.scrollLeft < 4;
      if (next) next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    const moveTrack = (direction) => track.scrollBy({
      left: direction * (cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0)),
      behavior: 'smooth'
    });

    root.querySelector('[data-cloud-x-ugc-track-prev]')?.addEventListener('click', () => moveTrack(-1));
    root.querySelector('[data-cloud-x-ugc-track-next]')?.addEventListener('click', () => moveTrack(1));
    track.addEventListener('scroll', updateTrackArrows, { passive: true });
    updateTrackArrows();

    const pausePreview = (card) => {
      const video = videoFromCard(card);
      video?.pause?.();
      card?.classList.remove('is-preview-playing');
    };
    const playPreview = (card) => {
      const video = videoFromCard(card);
      if (!video) return;
      cards.forEach((candidate) => {
        if (candidate !== card) pausePreview(candidate);
      });
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.play()
        .then(() => card.classList.add('is-preview-playing'))
        .catch(() => card.classList.remove('is-preview-playing'));
    };
    const syncMobilePreview = () => {
      if (fineHover.matches) return;
      let current = null;
      let ratio = 0;
      cards.forEach((card) => {
        const value = previewRatios.get(card) || 0;
        if (value > ratio) {
          ratio = value;
          current = card;
        }
      });
      if (current && ratio >= 0.55) playPreview(current);
      else cards.forEach(pausePreview);
    };

    const renderMute = () => {
      if (!mute) return;
      const muted = player?.tagName === 'VIDEO' ? player.muted : true;
      mute.innerHTML = volumeIcon(muted);
      mute.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      mute.setAttribute('aria-pressed', String(!muted));
    };
    const syncViewerState = () => {
      const isVideo = player?.tagName === 'VIDEO';
      const isPlaying = Boolean(isVideo && !player.paused);
      media.classList.toggle('is-playing', isPlaying);
      media.classList.toggle('is-paused', Boolean(isVideo && player.paused));
      if (center) {
        center.hidden = !isVideo;
        center.innerHTML = playIcon;
        center.setAttribute('aria-label', 'Play video');
      }
      if (mute) mute.hidden = !isVideo;
      renderMute();
    };
    const updateProgress = () => {
      if (player?.tagName === 'VIDEO' && Number.isFinite(player.duration) && player.duration > 0 && progress) {
        progress.value = Math.round(player.currentTime / player.duration * 1000);
      }
      if (player?.tagName === 'VIDEO' && !viewer.hidden) raf = requestAnimationFrame(updateProgress);
    };
    const stopPlayer = () => {
      cancelAnimationFrame(raf);
      raf = 0;
      player?.pause?.();
      player?.remove();
      player = null;
      media.querySelector('iframe')?.remove();
      media.classList.remove('is-playing', 'is-paused');
      if (progress) progress.value = 0;
    };
    const clearMini = () => {
      miniPlayer?.pause?.();
      miniPlayer?.remove();
      miniPlayer = null;
      mini.hidden = true;
      if (miniToggle) miniToggle.innerHTML = pauseIcon;
    };
    const renderMiniState = () => {
      if (!miniToggle || !miniPlayer) return;
      const paused = miniPlayer.paused;
      miniToggle.innerHTML = paused ? playIcon : pauseIcon;
      miniToggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    };
    const makePlayer = (card) => {
      const source = videoFromCard(card);
      if (source) {
        const clone = source.cloneNode(true);
        clone.removeAttribute('controls');
        clone.muted = false;
        clone.loop = true;
        clone.playsInline = true;
        clone.preload = 'auto';
        const restoreTime = () => {
          if (Number.isFinite(source.currentTime)) clone.currentTime = source.currentTime;
        };
        if (clone.readyState >= 1) restoreTime();
        else clone.addEventListener('loadedmetadata', restoreTime, { once: true });
        return clone;
      }
      const template = card.querySelector('[data-cloud-x-ugc-external-template]');
      if (template) {
        const fragment = template.content.cloneNode(true);
        const frame = fragment.querySelector('iframe');
        if (frame) return frame;
      }
      return null;
    };
    const refreshSides = () => {
      sides.forEach((side) => {
        const offset = Number(side.dataset.cloudXUgcOffset || 0);
        const target = viewerCards.length > 1
          ? viewerCards[modulo(viewerIndex + offset, viewerCards.length)]
          : null;
        const cover = coverFromCard(target);
        side.style.backgroundImage = cover ? `url("${cover}")` : 'none';
        side.hidden = !target || target === viewerCards[viewerIndex] || !cover;
      });
    };
    const togglePlayer = () => {
      if (player?.tagName !== 'VIDEO') return;
      if (player.paused) player.play().catch(syncViewerState);
      else player.pause();
    };
    const openViewerAt = (nextIndex) => {
      if (!viewerCards.length) return;
      const wasHidden = viewer.hidden;
      clearMini();
      viewerIndex = modulo(nextIndex, viewerCards.length);
      const card = viewerCards[viewerIndex];
      cards.forEach(pausePreview);
      stopPlayer();
      if (title) title.textContent = card.querySelector('.cloud-x-ugc-card-title')?.textContent?.trim() || '';
      player = makePlayer(card);
      if (player) {
        media.prepend(player);
        if (player.tagName === 'VIDEO') {
          player.addEventListener('play', syncViewerState);
          player.addEventListener('pause', syncViewerState);
          player.addEventListener('volumechange', renderMute);
        }
      }
      refreshSides();
      viewer.hidden = false;
      viewer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cloud-x-ugc-viewer-open');
      if (wasHidden) {
        lastFocus = document.activeElement;
        close?.focus?.({ preventScroll: true });
      }
      syncViewerState();
      if (player?.tagName === 'VIDEO') {
        player.play().catch(syncViewerState);
        updateProgress();
      }
    };
    const openAt = (cardIndex) => {
      const card = cards[modulo(cardIndex, cards.length)];
      const playableIndex = viewerCards.indexOf(card);
      if (playableIndex >= 0) openViewerAt(playableIndex);
    };
    const switchBy = (direction) => openViewerAt(viewerIndex + direction);
    const closeViewer = (mode) => {
      const shouldMini = (mode === 'backdrop' || mode === 'minimize') && player?.tagName === 'VIDEO';
      if (shouldMini) {
        miniPlayer = player;
        player = null;
        miniPlayer.removeEventListener('play', syncViewerState);
        miniPlayer.removeEventListener('pause', syncViewerState);
        miniPlayer.removeEventListener('volumechange', renderMute);
        cancelAnimationFrame(raf);
        raf = 0;
        miniMedia.replaceChildren(miniPlayer);
        miniPlayer.loop = true;
        miniPlayer.muted = true;
        miniPlayer.addEventListener('play', renderMiniState);
        miniPlayer.addEventListener('pause', renderMiniState);
        miniPlayer.play().catch(renderMiniState);
        mini.hidden = false;
        renderMiniState();
      } else {
        stopPlayer();
      }
      viewer.hidden = true;
      viewer.setAttribute('aria-hidden', 'true');
      if (shareSheet) shareSheet.hidden = true;
      document.body.classList.remove('cloud-x-ugc-viewer-open');
      media.classList.remove('is-playing', 'is-paused');
      lastFocus?.focus?.({ preventScroll: true });
      lastFocus = null;
    };

    cards.forEach((card, cardIndex) => {
      const open = () => openAt(cardIndex);
      card.addEventListener('click', open);
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open();
        }
      });
      card.addEventListener('pointerenter', () => {
        if (fineHover.matches) playPreview(card);
      });
      card.addEventListener('pointerleave', () => {
        if (fineHover.matches) pausePreview(card);
      });
    });

    const previewObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => previewRatios.set(entry.target, entry.intersectionRatio));
      syncMobilePreview();
    }, { root: null, threshold: [0, 0.25, 0.55, 0.7, 0.85, 1] });
    cards.forEach((card) => previewObserver.observe(card));

    close?.addEventListener('click', () => closeViewer('close'));
    minimize?.addEventListener('click', () => closeViewer('minimize'));
    dismiss?.addEventListener('click', () => closeViewer('backdrop'));
    viewerPrev?.addEventListener('click', () => switchBy(-1));
    viewerNext?.addEventListener('click', () => switchBy(1));
    sides.forEach((side) => side.addEventListener('click', () => switchBy(Number(side.dataset.cloudXUgcOffset || 0))));
    center?.addEventListener('click', togglePlayer);
    media.addEventListener('click', (event) => {
      if (event.target.closest('button, input, a, xo-product-quick-view-trigger, [role="button"]')) return;
      togglePlayer();
    });
    mute?.addEventListener('click', () => {
      if (player?.tagName !== 'VIDEO') return;
      player.muted = !player.muted;
    });
    progress?.addEventListener('input', () => {
      if (player?.tagName === 'VIDEO' && Number.isFinite(player.duration)) {
        player.currentTime = player.duration * Number(progress.value) / 1000;
      }
    });
    share?.addEventListener('click', () => {
      if (shareSheet) shareSheet.hidden = false;
    });
    shareClose?.addEventListener('click', () => {
      if (shareSheet) shareSheet.hidden = true;
    });
    productCard?.addEventListener('click', () => player?.pause?.());
    miniToggle?.addEventListener('click', () => {
      if (!miniPlayer) return;
      if (miniPlayer.paused) miniPlayer.play().catch(renderMiniState);
      else miniPlayer.pause();
    });
    mini?.addEventListener('click', (event) => {
      if (event.target.closest('button, a, [role="button"]')) return;
      if (!miniPlayer) return;
      if (miniPlayer.paused) miniPlayer.play().catch(renderMiniState);
      else miniPlayer.pause();
    });
    miniClose?.addEventListener('click', clearMini);
    fineHover.addEventListener?.('change', () => {
      cards.forEach(pausePreview);
      syncMobilePreview();
    });

    const keydown = (event) => {
      if (viewer.hidden) return;
      if (event.key === 'Escape') closeViewer('close');
      if (event.key === 'ArrowLeft') switchBy(-1);
      if (event.key === 'ArrowRight') switchBy(1);
      if (event.key === ' ' && event.target === viewer) {
        event.preventDefault();
        togglePlayer();
      }
    };
    document.addEventListener('keydown', keydown);

    root._cloudXUgcCleanup = () => {
      document.removeEventListener('keydown', keydown);
      previewObserver.disconnect();
      cards.forEach(pausePreview);
      stopPlayer();
      clearMini();
      viewer.remove();
      mini.remove();
      document.body.classList.remove('cloud-x-ugc-viewer-open');
      delete root.dataset.cloudXUgcStoriesReady;
    };
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll?.('.cloud-x-module--ugc').forEach(init);
    if (scope.matches?.('.cloud-x-module--ugc')) init(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelector?.('.cloud-x-module--ugc')?._cloudXUgcCleanup?.();
  });
})();
